import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { MenuListItem } from './MenuListItem';
import { MenuLink } from './MenuLink';
import { DisplayMode } from '../desktop/MenuDesktopContent';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../MenuUtils';

interface Props {
  item: MenuItem;
  menuSelectedPath: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  currentMenuPath: MenuItem[];
  displayMode?: DisplayMode;
  hideImage?: boolean;
  mobile?: false | { onMobileClick: (label: string) => void };
  closeMenu: () => void;
  onClick: (label: string) => void;
  onMobileClick?: (label: string) => void;
}

const MenuCategoryContent: FunctionComponent<Props> = ({
  item,
  menuSelectedPath,
  setMenuSelectedPath,
  currentMenuPath,
  displayMode,
  mobile,
  closeMenu,
  onClick
}) => {
  const { t } = useTranslation('sharedComponents');
  const children = item.children || [];

  return (
    <StyledContainer mobile={!!mobile}>
      <StyledPanelTitle>
        <StyledLabel>{item.label}</StyledLabel>
        <div>
          <MenuLink closeMenu={closeMenu} item={item}>
            {t('shared.menu.discoverGama')}
          </MenuLink>
        </div>
      </StyledPanelTitle>
      <StyledItems>
        {children.map((item, index) => (
          <StyledItem key={`panelItem_${index}`}>
            <MenuListItem
              withImages={true}
              item={item}
              // This function is define like an empty arrow function
              // because MenuCategoryContent is triggered twice.
              onClick={mobile ? () => mobile.onMobileClick(item.label) : () => onClick(item.label)}
              currentMenuPath={currentMenuPath}
              setMenuSelectedPath={setMenuSelectedPath}
              menuSelectedPath={menuSelectedPath}
              displayMode={displayMode}
              closeMenu={closeMenu}
            />
          </StyledItem>
        ))}
      </StyledItems>
    </StyledContainer>
  );
};

export default MenuCategoryContent;
const StyledContainer = styled.div<{ mobile: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  height: ${props => (props.mobile ? '100%' : 'auto')};

  img {
    max-height: 100%;

    &.img-placeholder {
      height: 220px;
      width: 100%;
      border: 1px solid gray;
      box-sizing: border-box;
    }
  }
`;

const StyledPanelTitle = styled.div`
  margin-top: 10px;
  display: flex;
  font-size: 20px;
  align-items: baseline;
  flex-direction: column;

  padding-bottom: 14px;
  border-bottom: 1px solid #ebebeb;

  .a,
  a {
    display: inline-block;
    margin-top: 8px;
    font-size: 14px;
    text-decoration: underline;
  }

  @media (max-width: 1024px) {
    font-size: 20px;
  }
`;

const StyledLabel = styled.div`
  font-family: 'Styrene Medium';
`;

const StyledItems = styled.ul`
  list-style: none;
  margin-top: 16px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    // flex: 1;
    height: calc(100vh - 190px);
    overflow-y: auto;
    padding: 0px 0 20px 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledItem = styled.li`
  font-size: 14px;
  margin-bottom: 10px;

  @media (max-width: 1024px) {
    margin-bottom: 20px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
